var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoreCuteImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 112,
    viewBox: "0 0 185 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158 2H26C22.6863 2 20 4.68629 20 8V104C20 107.314 22.6863 110 26 110H158C161.314 110 164 107.314 164 104V8C164 4.68629 161.314 2 158 2Z",
    fill: "white",
    stroke: "#0D5BA5",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 41V31H164V41H162C162 46.5228 157.523 51 152 51C146.477 51 142 46.5228 142 41L141.996 41.2799C141.848 46.6733 137.429 51 132 51C126.477 51 122 46.5228 122 41L121.996 41.2799C121.848 46.6733 117.429 51 112 51C106.477 51 102 46.5228 102 41L101.996 41.2799C101.848 46.6733 97.4292 51 92 51C86.4771 51 82 46.5228 82 41L81.9962 41.2799C81.8479 46.6733 77.4292 51 72 51C66.4772 51 62 46.5228 62 41L61.9962 41.2799C61.8479 46.6733 57.4292 51 52 51C46.4772 51 42 46.5228 42 41L41.9962 41.2799C41.8479 46.6733 37.4292 51 32 51C26.4772 51 22 46.5228 22 41H20Z",
    fill: "#93D9FF",
    stroke: "#93D9FF",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 106H162",
    stroke: "#DCF3FF",
    strokeWidth: 4,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10H162",
    stroke: "#DCF3FF",
    strokeWidth: 4,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71 98H113C116.314 98 119 100.686 119 104V110H65V104C65 100.686 67.6863 98 71 98Z",
    stroke: "#0D5BA5",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M158 2H26C22.6863 2 20 4.68629 20 8V104C20 107.314 22.6863 110 26 110H158C161.314 110 164 107.314 164 104V8C164 4.68629 161.314 2 158 2Z",
    stroke: "#0D5BA5",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61 23H34C30.6863 23 28 25.6863 28 29V82C28 85.3137 30.6863 88 34 88H61C64.3137 88 67 85.3137 67 82V29C67 25.6863 64.3137 23 61 23Z",
    fill: "#00BBFE",
    stroke: "#0D5BA5",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 70H62C63.6569 70 65 71.3431 65 73V83C65 84.6569 63.6569 86 62 86H33C31.3431 86 30 84.6569 30 83V70Z",
    fill: "#0087CD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 57H43C44.6569 57 46 58.3431 46 60V67C46 68.6569 44.6569 70 43 70H30V60C30 58.3431 31.3431 57 33 57Z",
    fill: "#0087CD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67 50.0801V60.2311L31.929 87.6336C29.6358 86.7902 28 84.5864 28 82.0006V80.5501L67 50.0801Z",
    fill: "#DCF3FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0012 51C30.5804 51 29.2289 50.7037 28.0049 50.1695C28.0012 46.6365 28.0049 42.6104 28.0606 41C31.1585 41 35.8054 41 42.0012 41C42.0012 46.5228 37.5241 51 32.0012 51ZM52.0012 51C46.4784 51 42.0012 46.5228 42.0012 41H62.0012C62.0012 46.5228 57.5241 51 52.0012 51ZM67.0674 49.7001C64.0419 47.9807 62.0012 44.7287 62.0012 41C64.2487 41 65.9342 41 67.058 41C67.0674 44.3332 67.0012 46 67.0674 49.7001ZM28.0176 31C41.0272 31 54.0368 31 67.0465 31C67.0418 31.3037 67.0418 34.637 67.0465 41H28.0606C28.0319 34.5835 28.0176 31.2502 28.0176 31Z",
    fill: "#0087CD",
    stroke: "#0087CD",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61 23H34C30.6863 23 28 25.6863 28 29V82C28 85.3137 30.6863 88 34 88H61C64.3137 88 67 85.3137 67 82V29C67 25.6863 64.3137 23 61 23Z",
    stroke: "#0D5BA5",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M150 23H123C119.686 23 117 25.6863 117 29V82C117 85.3137 119.686 88 123 88H150C153.314 88 156 85.3137 156 82V29C156 25.6863 153.314 23 150 23Z",
    fill: "#00BBFE",
    stroke: "#0D5BA5",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117 31H156.053C156.046 31.2843 156.042 31.9108 156.04 32.8794L156.039 33.5016C156.039 33.5753 156.039 33.6506 156.039 33.7273V34.459C156.039 34.5449 156.039 34.6322 156.039 34.7211L156.04 35.5623C156.042 37.0328 156.046 38.8453 156.053 41H156.006C156.005 41.3565 156.004 41.7572 156.004 42.1906L156.004 44.0708C156.007 46.0699 156.019 48.343 156.052 50.1452C154.813 50.6947 153.442 51 152 51C146.477 51 142 46.5228 142 41L142 41.0352C141.981 46.5419 137.511 51 132 51C126.477 51 122 46.5228 122 41L121.995 41.3244C121.882 44.8785 119.914 47.9645 117.027 49.6465C117.008 47.5465 117.003 45.3925 117.001 43.4472L117 31Z",
    fill: "#0087CD",
    stroke: "#0087CD",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M152 82H121C119.895 82 119 82.8954 119 84C119 85.1046 119.895 86 121 86H152C153.105 86 154 85.1046 154 84C154 82.8954 153.105 82 152 82Z",
    fill: "#0087CD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.998 51.6426V61.7936L122.485 87.9778C119.449 87.7202 117.057 85.2013 117 82.1117L155.998 51.6426Z",
    fill: "#DCF3FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M150 23H123C119.686 23 117 25.6863 117 29V82C117 85.3137 119.686 88 123 88H150C153.314 88 156 85.3137 156 82V29C156 25.6863 153.314 23 150 23Z",
    stroke: "#0D5BA5",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81 23H103C106.314 23 109 25.6863 109 29V98H75V29C75 25.6863 77.6863 23 81 23Z",
    fill: "#00BBFE",
    stroke: "#0D5BA5",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M75 94H109",
    stroke: "#0087CD",
    strokeWidth: 4,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75 41L75.0718 31H109.223L109.222 31.1501C109.215 32.0111 109.159 35.2944 109.054 41H109.107C109.107 44.4307 109.054 48.3106 109.054 50.5589C104.969 49.3013 102 45.4973 102 41L101.996 41.2799C101.848 46.6733 97.4292 51 92 51C86.4772 51 82 46.5228 82 41L81.9957 41.2953C81.8706 45.6106 79.0116 49.2405 75.0903 50.5134C75 47.2918 75 44.4028 75.0345 41H75Z",
    fill: "#0087CD",
    stroke: "#0087CD",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M100 56H84C82.3431 56 81 57.3431 81 59V64C81 65.6569 82.3431 67 84 67H100C101.657 67 103 65.6569 103 64V59C103 57.3431 101.657 56 100 56Z",
    fill: "#DCF3FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81 23H103C106.314 23 109 25.6863 109 29V98H75V29C75 25.6863 77.6863 23 81 23Z",
    stroke: "#0D5BA5",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 41C17.5228 41 22 36.5228 22 31C16.182 31 9.37333 31 2 31C2 36.5228 6.47715 41 12 41Z",
    fill: "#FF646A",
    stroke: "#0D5BA5",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 41C37.5228 41 42 36.5228 42 31C36.182 31 29.3733 31 22 31C22 36.5228 26.4772 41 32 41Z",
    fill: "#DCF3FF",
    stroke: "#0D5BA5",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 41C57.5228 41 62 36.5228 62 31C56.182 31 49.3733 31 42 31C42 36.5228 46.4772 41 52 41Z",
    fill: "#FF646A",
    stroke: "#0D5BA5",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 41C77.5228 41 82 36.5228 82 31C76.182 31 69.3733 31 62 31C62 36.5228 66.4772 41 72 41Z",
    fill: "#DCF3FF",
    stroke: "#0D5BA5",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92 41C97.5228 41 102 36.5228 102 31C96.182 31 89.3733 31 82 31C82 36.5228 86.4772 41 92 41Z",
    fill: "#FF646A",
    stroke: "#0D5BA5",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112 41C117.523 41 122 36.5228 122 31C116.182 31 109.373 31 102 31C102 36.5228 106.477 41 112 41Z",
    fill: "#DCF3FF",
    stroke: "#0D5BA5",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132 41C137.523 41 142 36.5228 142 31C136.182 31 129.373 31 122 31C122 36.5228 126.477 41 132 41Z",
    fill: "#FF646A",
    stroke: "#0D5BA5",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152 41C157.523 41 162 36.5228 162 31C156.182 31 149.373 31 142 31C142 36.5228 146.477 41 152 41Z",
    fill: "#DCF3FF",
    stroke: "#0D5BA5",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172 41C177.523 41 182 36.5228 182 31C176.182 31 169.373 31 162 31C162 36.5228 166.477 41 172 41Z",
    fill: "#FF646A",
    stroke: "#0D5BA5",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148 14H164L182 31H162L148 14Z",
    fill: "#FFB6B7",
    stroke: "#0D5BA5",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132 14H148L162 31H142L132 14Z",
    fill: "white",
    stroke: "#0D5BA5",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116 14H132L142 31H122L116 14Z",
    fill: "#FFB6B7",
    stroke: "#0D5BA5",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 14H116L122 31H102L100 14Z",
    fill: "white",
    stroke: "#0D5BA5",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84 14H100L102 31H82L84 14Z",
    fill: "#FFB6B7",
    stroke: "#0D5BA5",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 14H84L82 31H62L68 14Z",
    fill: "white",
    stroke: "#0D5BA5",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 14H68L62 31H42L52 14Z",
    fill: "#FFB6B7",
    stroke: "#0D5BA5",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 14H52L42 31H22L36 14Z",
    fill: "white",
    stroke: "#0D5BA5",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 14H36L22 31H2L20 14Z",
    fill: "#FFB6B7",
    stroke: "#0D5BA5",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreCuteImage);
export default __webpack_public_path__ + "static/media/store-cute-image.e08458afc890b2ebedf51a673ec73dfd.svg";
export { ForwardRef as ReactComponent };